const elTags = document.querySelectorAll('.tags');

function setEventsItems() {
    const elsTagsHide = document.querySelectorAll('.tags__cont_hide .tags__item');
    const elsTagsClose = document.querySelectorAll('.tags__close');

    [...elsTagsHide, ...elsTagsClose].forEach((item) => {
        item.addEventListener('click', () => {
            tagsAddAndRemove();
        });
    });
}

function toggleClassSlide(item) {
    item.closest('.tags').classList.toggle('tags_hide-active');
}

function tagsAddAndRemove(callPageLoad = false) {
    elTags.forEach((item) => {
        const elsItemHide = item.querySelectorAll('.tags__cont_hide .tags__item');
        const elsItem = item.querySelectorAll('.tags__cont_visible .tags__item');

        function createItemVisible(itemHide) {
            const itemVisibleNew = document.createElement('div');

            itemVisibleNew.classList.add('tags__item');
            itemVisibleNew.innerHTML = itemHide.innerHTML;
            itemVisibleNew.textContent = itemHide.textContent.slice(1);
            itemVisibleNew.insertAdjacentHTML('beforeend', `<label class="tags__close" for="${itemHide.getAttribute('for')}"><input class="tags__input" type="checkbox" name="UF_USER_TAGS[]" value="${itemHide.querySelector('.tags__input').getAttribute('value')}" id="${itemHide.getAttribute('for')}" checked></label>`);
            itemHide.parentNode.removeChild(itemHide);
            item.querySelector('.tags__cont_visible').append(itemVisibleNew);
            itemVisibleNew.removeEventListener('click', createItemVisible);
            itemVisibleNew.querySelector('.tags__close').addEventListener('click', () => createItemHide(itemVisibleNew));
            setEventsItems();
        }

        function createItemHide(itemVisible) {
            const itemHideNew = document.createElement('label');

            itemHideNew.classList.add('tags__item');
            itemHideNew.classList.add('tags__item_orange');
            itemHideNew.textContent = `+${itemVisible.textContent}`;
            itemHideNew.setAttribute('for', itemVisible.querySelector('.tags__close').getAttribute('for'));
            itemHideNew.insertAdjacentHTML('beforeend', `<input class="tags__input" type="checkbox" name="UF_USER_TAGS[]" value="${itemVisible.querySelector('.tags__input').getAttribute('value')}" id="${itemVisible.querySelector('.tags__close').getAttribute('for')}">`);
            itemVisible.parentNode.removeChild(itemVisible);
            item.querySelector('.tags__cont_hide').append(itemHideNew);
            itemHideNew.removeEventListener('click', createItemHide);
            itemHideNew.addEventListener('click', () => createItemVisible(itemHideNew));
            setEventsItems();
        }

        if (elsItemHide.length === 0) {
            item.querySelector('.tags__hide').style.display = 'none';
        } else {
            item.querySelector('.tags__hide').style.display = '';
        }

        if (elsItem.length === 0) {
            item.classList.add('tags_visible-empty');
        } else {
            item.classList.remove('tags_visible-empty');
        }

        if (callPageLoad) {
            item.querySelector('.tags__item_add').addEventListener('click', () => {
                toggleClassSlide(item);
            });

            item.querySelector('.tags__item_close').addEventListener('click', () => {
                item.querySelector('.tags__hide').style.display = '';
                toggleClassSlide(item);
            });

            elsItemHide.forEach((itemHide) => {
                itemHide.addEventListener('click', () => {
                    createItemVisible(itemHide);
                });
            });

            elsItem.forEach((itemVisible) => {
                itemVisible.querySelector('.tags__close').addEventListener('click', () => {
                    createItemHide(itemVisible);
                });
            });
        }
    });
}

tagsAddAndRemove(true);
setEventsItems();